import { render, staticRenderFns } from "./depth.vue?vue&type=template&id=63f21f99&scoped=true&"
import script from "./depth.vue?vue&type=script&lang=js&"
export * from "./depth.vue?vue&type=script&lang=js&"
import style0 from "./depth.vue?vue&type=style&index=0&id=63f21f99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f21f99",
  null
  
)

export default component.exports